
import { Injectable } from '@angular/core';

/*
  Generated class for the MyPosProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MyPosProvider {
  public UName:string = "";
  public MyDomain:string = "";//http://waheedapi.waheed-store.com "http://service.waheed-store.com";
  public MyTestDomain:string = "http://localhost:1622";
  constructor() {
    console.log('Hello MyPosProvider Provider');
   }
}



// WEBPACK FOOTER //
// ./src/providers/my-pos/my-pos.ts